<template>
  <div class="logo">
    <img src="../../assets/HSC.png" width="90" height="90" />
    <svg height="100" width="15"></svg>
    <img src="../../assets/PKU.png" width="90" height="90" />
    <svg height="100" width="15"></svg>
    <img src="../../assets/logo.png" width="90" height="90" />
    <svg height="100" width="360">
      <text x="15" y="50" fill="#4e4e4e" font-size="26" font-weight="bold" letter-spacing="5">轻元素量子材料交叉平台</text>
      <text x="15" y="70" fill="#4e4e4e" font-size="11" font-weight="bold" letter-spacing="0.15">
        Interdisciplinary Institute of Light-Element Quantum Materials
      </text>
    </svg>
    <svg height="100" width="5">
      <text x="0" y="58" fill="#4e4e4e" font-size="40" font-weight="bold">
        |
      </text>
    </svg>
    <svg height="100" width="410">
      <text x="15" y="50" fill="#4e4e4e" font-size="26" font-weight="bold">北京大学轻元素先进材料研究中心</text>
      <text x="15" y="70" fill="#4e4e4e" font-size="11" font-weight="bold" letter-spacing="0.1">
        Peking University Research Center for Light-Element Advanced Materials
      </text>
    </svg>
    <svg height="100" width="53">
    </svg>
    <a href="http://ileqm.pku.edu.cn">
      <svg height="100" width="40">
        <text x="5" y="70" fill="#4e4e4e" font-size="15" font-weight="bold">中文</text>
      </svg>
    </a>
    <svg height="100" width="12">
      <text x="0" y="70" fill="#4e4e4e" font-size="15" font-weight="bold">/</text>
    </svg>
    <a href="http://ileqm.pku.edu.cn/en">
      <svg height="100" width="60">
        <text x="0" y="70" fill="#4e4e4e" font-size="15" font-weight="bold">English</text>
      </svg>
    </a>
  </div>
</template>
<script>
export default {
};
</script>
<style lang="scss" scoped>
.logo {
  padding: 0;
  margin: 0 auto;
  height: 100px;
  width: 1300px;

}
.language-version {
  padding-left: 60px;
  color: #000;
}
</style>
